

const kmsToMiles = (value) => {
  if (!value) return;
  return (value * 0.621371).toFixed(2);
}


//  CAPATILIAZE THE FIRST LETTER OF STRING
const capitalizeFirstLetter = (str) => {
  if (!str) return;
  return str.charAt(0)?.toUpperCase() + str?.slice(1);
};


const calculateDateDifference = (start, end) => {
  if (start && end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    // Calculate the difference in milliseconds
    const diffInMs = endDate - startDate;
    // Convert milliseconds to days and round up
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
  }
};

function formatDate(dateString) {
  if (!dateString) return;
  const date = new Date(dateString);

  // Get day, month, and time components
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name (e.g., "Aug")
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Format minutes to always show two digits
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

  // Return formatted string
  return `${day} ${month}`
  // , ${hours}:${minutesFormatted} ${ampm}`;
}

function formatTime(timeString) {
  if (!timeString) return;
  const date = new Date(timeString);

  // Get day, month, and time components
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name (e.g., "Aug")
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Format minutes to always show two digits
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

  // Return formatted string
  return `${hours}:${minutesFormatted} ${ampm}`;
}

export {
  kmsToMiles,
  capitalizeFirstLetter,
  calculateDateDifference,
  formatDate,
  formatTime
}